"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageExtraction = exports.toMessage = exports.CustomParsingError = exports.BasicParsingError = exports.EnumParsingError = exports.UnionParsingError = exports.TupleItemParsingError = exports.TupleSizeParsingError = exports.ListParsingError = exports.RecordParsingError = exports.createSchema = void 0;
;
const createSchema = (fn) => ({
    parse: (value) => {
        return fn(value).mapError(toMessage);
    },
    debug: fn,
});
exports.createSchema = createSchema;
class RecordParsingError extends Error {
    constructor(args) {
        super();
        this.tag = 'RecordParsingError';
        this.parserName = args.parserName;
        this.expectedType = args.expectedType;
        this.receivedType = getType(args.receivedValue);
        this.key = args.key;
        this.innerError = args.innerError;
    }
}
exports.RecordParsingError = RecordParsingError;
class ListParsingError extends Error {
    constructor(args) {
        super();
        this.tag = 'ListParsingError';
        this.parserName = args.parserName;
        this.expectedType = args.expectedType;
        this.receivedType = getType(args.receivedValue);
        this.index = args.index;
        this.innerError = args.innerError;
    }
}
exports.ListParsingError = ListParsingError;
class TupleSizeParsingError extends Error {
    constructor(args) {
        super();
        this.tag = 'TupleSizeParsingError';
        this.parserName = args.parserName;
        this.expectedType = args.expectedType;
        this.expectedLength = args.expectedLength;
        this.receivedLength = args.receivedLength;
    }
}
exports.TupleSizeParsingError = TupleSizeParsingError;
class TupleItemParsingError extends Error {
    constructor(args) {
        super();
        this.tag = 'TupleItemParsingError';
        this.parserName = args.parserName;
        this.expectedType = args.expectedType;
        this.receivedType = getType(args.receivedValue);
        this.index = args.index;
        this.innerError = args.innerError;
    }
}
exports.TupleItemParsingError = TupleItemParsingError;
class UnionParsingError extends Error {
    constructor(args) {
        super();
        this.tag = 'UnionParsingError';
        this.parserName = args.parserName;
        this.expectedType = args.expectedType;
        this.wasNotOneOfThose = args.wasNotOneOfThose;
        this.receivedType = getType(args.receivedValue);
    }
}
exports.UnionParsingError = UnionParsingError;
class EnumParsingError extends Error {
    constructor(args) {
        super();
        this.tag = 'EnumParsingError';
        this.parserName = args.parserName;
        this.expectedType = args.expectedType;
        this.wasNotOneOfThose = args.wasNotOneOfThose;
        this.receivedType = getType(args.receivedValue);
    }
}
exports.EnumParsingError = EnumParsingError;
class BasicParsingError extends Error {
    constructor(parserName, expectedType, receivedType, innerError) {
        super();
        this.tag = 'BasicParsingError';
        this.parserName = parserName;
        this.expectedType = expectedType;
        this.receivedType = receivedType;
        this.innerError = innerError;
    }
    static from(args) {
        return new BasicParsingError(args.parserName, args.expectedType, getType(args.receivedValue), args.innerError);
    }
}
exports.BasicParsingError = BasicParsingError;
class CustomParsingError extends Error {
    constructor(parserName, expectedType, receivedType, innerError) {
        super();
        // This class is for general usage. The other one are for internal use for primitive parser (rec,list,arr)
        // If it was a lib, then it would be the only export ParsingError constructor.
        this.tag = 'CustomParsingError';
        this.parserName = parserName;
        this.expectedType = expectedType;
        this.receivedType = receivedType;
        this.innerError = innerError;
    }
    static from(expectedType, receivedValue, innerError = undefined) {
        return new CustomParsingError(expectedType, expectedType, getType(receivedValue), innerError);
    }
}
exports.CustomParsingError = CustomParsingError;
const addArticle = (word, capitalize = false) => {
    if (word.length > 0 && ['a', 'e', 'i', 'o', 'u', 'y'].includes(word[0])) {
        return `${capitalize ? 'A' : 'a'}n ${word}`;
    }
    return `${capitalize ? 'A' : 'a'} ${word}`;
};
function toJSONPath(pathStack) {
    let jsonPath = '';
    for (let i = 0; i < pathStack.length; i++) {
        const frame = pathStack[i];
        if (typeof frame === 'number') {
            jsonPath += `[${frame}]`;
        }
        if (typeof frame === 'string') {
            jsonPath += frame;
        }
        if (i < pathStack.length - 1) {
            if (typeof pathStack[i + 1] === 'string') {
                jsonPath += '.';
            }
        }
    }
    return jsonPath;
}
function toMessage(error) {
    return messageExtraction({ error, firstExpectedType: error.expectedType, pathStack: [] });
}
exports.toMessage = toMessage;
function messageExtraction(context) {
    let currentContext = Object.assign({}, context);
    while (true) {
        const { error, pathStack, firstExpectedType } = currentContext;
        switch (error.tag) {
            case "ListParsingError": {
                currentContext = Object.assign(Object.assign({}, currentContext), { error: error.innerError, pathStack: pathStack.concat([error.index]) });
                continue;
            }
            case "RecordParsingError": {
                // Required key is missing (It's a leaf you can't have anything after)
                if (error.innerError) {
                    currentContext = Object.assign(Object.assign({}, currentContext), { error: error.innerError, pathStack: pathStack.concat([error.key]) });
                    continue;
                }
                const missingKeyMessage = `The ${error.expectedType} is missing the required property "${error.key}"`;
                if (pathStack.length > 0) {
                    return missingKeyMessage + ` in "<root>.${toJSONPath(pathStack)}".`;
                }
                else {
                    return missingKeyMessage + ".";
                }
            }
            case "UnionParsingError": {
                let msg = `Failed to parse ${addArticle(firstExpectedType)}. We received ${addArticle(error.receivedType)}`;
                const path = toJSONPath(pathStack);
                if (path.length > 0) {
                    msg += ` at "<root>.${path}"`;
                }
                else {
                    msg += "";
                }
                return `${msg} but it was supposed to one of (${error.wasNotOneOfThose.join(' | ')}).`;
            }
            case "EnumParsingError": {
                let msg = `Expected ${addArticle(firstExpectedType)}`;
                const path = toJSONPath(pathStack);
                if (path.length > 0) {
                    msg += `at "<root>.${path}"`;
                }
                else {
                    msg += ".";
                }
                return `${msg} It was supposed to be one of: ${error.wasNotOneOfThose.join(',')}. but it was ${addArticle(error.receivedType)}.`;
            }
            case "TupleSizeParsingError": {
                return `Expected ${addArticle(firstExpectedType)} and the length was supposed to be ${error.expectedLength} but it was ${error.receivedLength}.`;
            }
            case "TupleItemParsingError": {
                if (error.innerError) {
                    currentContext = Object.assign(Object.assign({}, currentContext), { error: error.innerError, pathStack: pathStack.concat([error.index]) });
                    continue;
                }
            }
            case "CustomParsingError":
            case "BasicParsingError": {
                if (error.innerError) {
                    currentContext = Object.assign(Object.assign({}, currentContext), { error: error.innerError });
                    continue;
                }
                // If first pathstack === 1 dont add the prefix with firstexpectedtype
                if (pathStack.length > 0) {
                    return `Expected ${addArticle(firstExpectedType)} and the value at "${typeof pathStack[0] === 'string' ? "<root>." : ""}${toJSONPath(pathStack)}" was supposed to be ${addArticle(error.expectedType)} but it was ${addArticle(error.receivedType)}.`;
                }
                else {
                    return `Expected ${addArticle(firstExpectedType)} but it was ${addArticle(error.receivedType)}.`;
                }
            }
        }
    }
}
exports.messageExtraction = messageExtraction;
const getType = (value) => {
    if (value === null) {
        return 'null';
    }
    if (value === undefined) {
        return 'undefined';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    if (typeof value === 'object') {
        if (value.constructor && value.constructor.prototype) {
            const properties = Object.getOwnPropertyNames(value.constructor.prototype);
            const classname = value.constructor.name;
            if (properties.length > 0 && properties[0] === 'constructor' && classname !== 'Object') {
                return `${classname} class instance`;
            }
        }
        return 'object';
    }
    return typeof value;
};
